import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SdsnShopWindowComponent } from './sdsn-shop-window.component';
import { HeaderModule } from 'src/app/shared/components/header/header.module';
import { WindowShopManagerNutritionTableModule } from 'src/app/shared/components/window-shop-manager-nutrition-table/window-shop-manager-nutrition-table.module';
import { PriceTableModule } from 'src/app/shared/components/price-table/price-table.module';
import { CarouselSwiperModule } from 'src/app/shared/components/carousel-swiper/carousel-swiper.module';
import { ProductSdsnModule } from 'src/app/shared/components/product-sdsn/product-sdsn.module';
import { WindowShopManagerHeaderModule } from 'src/app/shared/components/window-shop-manager-header/window-shop-manager-header.module';
import { PaymentMethodsModule } from 'src/app/shared/components/payment-methods/payment-methods.module';
import { MatDividerModule } from '@angular/material/divider';
import { ComparativeSdsnModule } from 'src/app/shared/components/comparative-sdsn/comparative-sdsn.module';



@NgModule({
  declarations: [
    SdsnShopWindowComponent
  ],
  imports: [
    CommonModule,
    ComparativeSdsnModule,
    WindowShopManagerHeaderModule,
    WindowShopManagerNutritionTableModule,
    PriceTableModule,
    CarouselSwiperModule,
    ProductSdsnModule,
    
    PaymentMethodsModule,
    MatDividerModule
  ],
  exports:[
    SdsnShopWindowComponent
  ]
})
export class SdsnShopWindowModule { }
